"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROffice = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var Resources_1 = require("../../Resources");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var constants_1 = require("../../constants");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var PROffice = (function (_super) {
    __extends(PROffice, _super);
    function PROffice() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PR_OFFICE,
            tags: [Tags_1.Tags.EARTH],
            cost: 7,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.UNITY); }),
            metadata: {
                cardNumber: 'T09',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(1).br;
                    b.megacredits(1).slash().earth().played;
                }),
                description: 'Requires that Unity are ruling or that you have 2 delegates there. Gain 1 TR. Gain 1 M€ for each Earth tag you have, including this.',
            },
        }) || this;
    }
    PROffice.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST);
        }
        return true;
    };
    PROffice.prototype.play = function (player) {
        player.increaseTerraformRating();
        var amount = player.getTagCount(Tags_1.Tags.EARTH) + 1;
        player.addResource(Resources_1.Resources.MEGACREDITS, amount);
        return undefined;
    };
    return PROffice;
}(Card_1.Card));
exports.PROffice = PROffice;
//# sourceMappingURL=PROffice.js.map